import {
  CTA,
  Text,
  TokenTextAppearance,
  TokenTextColor,
} from '@volkswagen-onehub/components-core';
import { ReactNode } from 'react';
import Box from '../Box/Box';
import { useTribalContext } from '@/context/tribal';
import Superscript from '../Superscript/Superscript';
import { StyledFootnote } from './Footnote.styles';

const FootnoteContent = ({
  children,
  margin = true,
}: {
  children: ReactNode;
  margin?: boolean;
}) => (
  <Box
    as={Text}
    appearance={TokenTextAppearance.copy100}
    color={TokenTextColor.inherit}
    mb={margin ? 'static350' : 'static0'}
  >
    {children}
  </Box>
);

const Footnote = () => {
  const { contentManager } = useTribalContext();

  return (
    <StyledFootnote>
      <FootnoteContent>
        {contentManager.get('footnote-section-1')}
      </FootnoteContent>

      <FootnoteContent>
        <strong>
          <Superscript />
          {contentManager.get('footnote-section-2-bold')}
        </strong>{' '}
        {contentManager.get('footnote-section-2-normal')}{' '}
        <CTA
            tag="a"
            emphasis="tertiary"
            href={contentManager.get('footnote-href')}
          >
            {contentManager.get('footnote-href')}
          </CTA>
        <br />
        <Box as="span" display="block" mt="static350">
          {contentManager.get('footnote-href-text')}
        </Box>
      </FootnoteContent>

      <FootnoteContent>
        <strong>{contentManager.get('footnote-section-3-bold')}</strong>{' '}
        {contentManager.get('footnote-section-3-normal')}
      </FootnoteContent>

      <FootnoteContent margin={false}>
        <strong>{contentManager.get('footnote-section-4-bold')}</strong>{' '}
        {contentManager.get('footnote-section-4-normal')}
      </FootnoteContent>
    </StyledFootnote>
  );
};

export default Footnote;
